import { ref, watch } from 'vue'
import { defineStore } from 'pinia'
import { useStorage } from '@vueuse/core'
import { i18n, setLocale } from '../composables/userLanguage'

const STORE_KEY = 'protargeting-personal'

export const usePersonalStore = defineStore(STORE_KEY, () => {
  const email = useStorage<string | undefined>(`${STORE_KEY}-email`, undefined)
  const name = useStorage<string | undefined>(`${STORE_KEY}-name`, undefined)
  const token = useStorage<string | undefined>(`${STORE_KEY}-token`, undefined)
  const signedInAs = useStorage<string | undefined>(`${STORE_KEY}-signed-email`, undefined)
  const locale = useStorage<'en' | 'ja'>(`${STORE_KEY}-locale`, 'en')
  const isOpen = ref(false)

  watch(
    locale,
    () => {
      if (locale.value === i18n.global.locale.value) return
      setLocale(locale.value)
    },
    { immediate: true },
  )

  return { email, name, token, signedInAs, locale, isOpen }
})
